import { Schedule } from "../components/Schedule";

/**
 * Default weekly sending window for a new campaign: Mon–Fri 08:00–17:00 active,
 * weekend off. Shared seed for the create/edit campaign modals. Schedule updates
 * are immutable (each toggle replaces the day object), so this constant is never
 * mutated in place and is safe to reuse as a state seed.
 */
export const DEFAULT_CAMPAIGN_SCHEDULE: Schedule = {
	monday: { active: true, fromTime: "08:00", toTime: "17:00" },
	tuesday: { active: true, fromTime: "08:00", toTime: "17:00" },
	wednesday: { active: true, fromTime: "08:00", toTime: "17:00" },
	thursday: { active: true, fromTime: "08:00", toTime: "17:00" },
	friday: { active: true, fromTime: "08:00", toTime: "17:00" },
	saturday: { active: false, fromTime: "08:00", toTime: "17:00" },
	sunday: { active: false, fromTime: "08:00", toTime: "17:00" },
};
